import { render } from "./AdminEstateInclusions.vue?vue&type=template&id=5509bd10&scoped=true&ts=true&lang=pug"
import script from "./AdminEstateInclusions.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminEstateInclusions.vue?vue&type=script&lang=ts&setup=true"

import "./AdminEstateInclusions.vue?vue&type=style&index=0&id=5509bd10&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5509bd10"]])

export default __exports__